var _path, _path2, _path3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 26H25C23.3431 26 22 27.3431 22 29V39C22 40.6569 23.3431 42 25 42H35C36.6569 42 38 40.6569 38 39V38H36V39C36 39.5523 35.5523 40 35 40H25C24.4477 40 24 39.5523 24 39V29C24 28.4477 24.4477 28 25 28H26V26Z",
    fill: "#1A1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 24H29C28.4477 24 28 24.4477 28 25V35C28 35.5523 28.4477 36 29 36H39C39.5523 36 40 35.5523 40 35V25C40 24.4477 39.5523 24 39 24ZM29 22C27.3431 22 26 23.3431 26 25V35C26 36.6569 27.3431 38 29 38H39C40.6569 38 42 36.6569 42 35V25C42 23.3431 40.6569 22 39 22H29Z",
    fill: "#1A1D1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7071 27.2929C38.0976 27.6834 38.0976 28.3166 37.7071 28.7071L33.7071 32.7071C33.3166 33.0976 32.6834 33.0976 32.2929 32.7071L30.2929 30.7071C29.9024 30.3166 29.9024 29.6834 30.2929 29.2929C30.6834 28.9024 31.3166 28.9024 31.7071 29.2929L33 30.5858L36.2929 27.2929C36.6834 26.9024 37.3166 26.9024 37.7071 27.2929Z",
    fill: "#1A1D1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 31,
    stroke: "#EFEFEF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.2258679196c46534a1be1829743507e7.svg";
export { ForwardRef as ReactComponent };